import * as LoadingState from '@blueberry/constants/loadingState';

export const types = {
  CHANGE_CHANNELS: 'CHANGE_CHANNELS',
  FETCH_SINGLE_CHANNEL: 'FETCH_SINGLE_CHANNEL',
  FETCH_SINGLE_CHANNEL_SUCCESS: 'FETCH_SINGLE_CHANNEL_SUCCESS',
  FETCH_SINGLE_CHANNEL_FAILURE: 'FETCH_SINGLE_CHANNEL_FAILURE',
};

export const actions = {
  changeChannels: channels => ({
    type: types.CHANGE_CHANNELS,
    payload: {
      channels,
    },
  }),
  fetchSingleChannel: id => ({
    type: types.FETCH_SINGLE_CHANNEL,
    payload: {
      id,
    },
  }),
  fetchSingleChannelSuccess: singleChannel => ({
    type: types.FETCH_SINGLE_CHANNEL_SUCCESS,
    payload: {
      singleChannel,
    },
  }),
  fetchSingleChannelFailure: () => ({
    type: types.FETCH_SINGLE_CHANNEL_FAILURE,
  }),
};

const initialState = {
  channels: [],
  singleChannel: {},
  status: LoadingState.EMPTY,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case types.CHANGE_CHANNELS:
      return {
        ...state,
        channels: action.payload.channels,
      };
    case types.FETCH_SINGLE_CHANNEL:
      return {
        ...state,
        status: LoadingState.LOADING,
      };
    case types.FETCH_SINGLE_CHANNEL_SUCCESS:
      return {
        ...state,
        singleChannel: action.payload.singleChannel,
        status: LoadingState.READY,
      };
    case types.FETCH_SINGLE_CHANNEL_FAILURE:
      return {
        ...state,
        status: LoadingState.ERROR,
      };
    default:
      return state;
  }
};

export default reducer;
// get the first 4 posts and remove the rest.
export const transferChannelPosts = channels => {
  return channels.map(channel => ({
    ...channel,
    posts: channel.posts.slice(0, 4),
  }));
};

export const getChannels = state => state.channel.channels;
export const getSingleChannel = state => state.channel.singleChannel;



// WEBPACK FOOTER //
// ./app/redux/channel.js